const isDeletedStaff = firstName => firstName === 'Gelöschter';

export default isDeletedStaff;
